const TOKEN_SESSION_PROVIDERS = {
  AUTH_TOKEN: 'auth-token',
  TOKEN_EXPIRATION_TIME: 'token-expiration-time'
}

export default TOKEN_SESSION_PROVIDERS
export { TOKEN_SESSION_PROVIDERS }
